import { bgRed, green, headingBlue, maroon, orange } from "../../../assets/colors"

export const cardStyle={
    width: '10rem',
    height: '13rem',
    border: '1px solid grey',
    borderRadius: '0.9rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: '0.2rem'
}

export const imageBoxStyle = {
    width: '80%',
    height: '40%',
    padding: '0.4rem',
    display:'flex',
    justifyContent:'center',
    alignItems:'center'
}

export const imageStyle = {
    width: '80%',
    height: '100%'
    // maxWi
}

export const detailsBoxStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0.3rem'
}

export const nameTextStyle= {
    fontSize: '0.85rem',
    fontWeight: '600',
    textAlign: 'center',
    color: maroon
}

export const detailsTextStyle = {
    fontSize: '0.6rem',
    fontWeight: '600',
    textAlign: 'center'
}